import { makeAutoObservable } from 'mobx';
import {AuthModel} from "../model/auth-model";
import {HTTP_STATUS_CODE} from "../utils/UHttp";

type TokenStatus = 'verifying' | 'valid' | 'invalid' | 'expired' | 'already-used';

export class ResetPasswordFormViewModel {
    newPassword: string = '';
    confirmNewPassword: string = '';
    errorMessage: string | null = null;
    isLoading: boolean = false;
    tokenParam : string | null = null
    success: boolean = false
    tokenStatus: TokenStatus = 'verifying';
    private authModel: AuthModel;

    constructor() {
        makeAutoObservable(this);
        this.authModel = AuthModel.getInstance();

    }

    get getNewPassword() {
        return this.newPassword
    }
    get getisLoading() {
        return this.isLoading
    }
    get getSuccess() {
        return this.success
    }
    get getErrorMessage() {
        return this.errorMessage
    }
    get getConfirmNewPassword() {
        return this.confirmNewPassword
    }
    get getTokenParam(){
        return this.tokenParam
    }
    get getTokenStatus(){
        return this.tokenStatus
    }

    setToken = (token: string | null) => {
        this.tokenParam = token;
        if (token) {
            this.verifyToken(token);
        }
    };

    setTokenStatus = (status: TokenStatus) => {
        this.tokenStatus = status;
    };

    setSuccess = (success: boolean) => {
        this.success = success;
    };

    setNewPassword = (newPassword: string) => {
        this.newPassword = newPassword;
    };
    setIsLoading = (isLoading: boolean) => {
        this.isLoading = isLoading;
    };
    setConfirmNewPassword = (confirmNewPassword: string) => {
        this.confirmNewPassword = confirmNewPassword;
    };
    setErrorMessage = (message: string | null) => {
        this.errorMessage = message;
    };

    verifyToken = async (token: string) => {
        this.setTokenStatus('verifying');
        try {
            const result = await this.authModel.handleVerifyResetToken(token);

            if (result.status === HTTP_STATUS_CODE.OK && result.success) {
                this.setTokenStatus('valid');
            } else if (result.tokenExpired) {
                this.setTokenStatus('expired');
            } else if (result.message?.includes('invalide') || result.message?.includes('invalid')) {
                this.setTokenStatus('already-used');
            } else {
                this.setTokenStatus('invalid');
            }
        } catch (error: any) {
            console.error('ResetPasswordFormViewModel.verifyToken', error);
            this.setTokenStatus('invalid');
        }
    };

    handleForgotPassword = async (e: any) => {
        e.preventDefault()
        this.setIsLoading(true)
        this.setErrorMessage("")
        try {
            if(!this.tokenParam) return
            const result = await this.authModel.handleResetPassword(this.tokenParam, this.newPassword, this.confirmNewPassword)
            if(result.status === HTTP_STATUS_CODE.OK) {
                this.setSuccess(true);
            }
            this.setErrorMessage(result.message);

        } catch (error: any) {
            console.error( "ResetPasswordFormViewModel.handleForgotPassword",error.response.data.messagee)
        } finally {
            this.setIsLoading(false)
        }
    }
}

const resetPasswordFormViewModel = new ResetPasswordFormViewModel()

export const useResetPasswordFormViewModel = () => {
    return resetPasswordFormViewModel
}